export default {
      id: "merge-usage",
      viewBox: "0 0 50 36",
      url: "/dist/svg/" + "sprite.svg#merge-usage",
      toString: function () {
        return this.url;
      }
    }